<template>
	<div class="map-container">
		<div id="map" ref="mapContainer"></div>
		<div class="controls">
			<button class="nav-btn" @click="startNavigation" :disabled="!isPositionReady">
				{{ isNavigating ? '导航中...' : '开始导航' }}
			</button>
			<button class="nav-btn" @click="openBaiduNav" :disabled="!isPositionReady">
				{{ isNavigating ? '导航中...' : '百度地图APP' }}
			</button>
			<el-button type="link" @click="toList">返回列表</el-button>
			<div class="location-info">
				<p><span class="label">商户位置:</span> {{ formattedMerchantPoint }}</p>
				<p><span class="label">我的位置:</span> {{ userPoint.lat }},{{ userPoint.lng }}</p>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'BaiduMapNavigation',
		data() {
			return {
				merchantName: '',
				merchantLat: '',
				merchantLng: '',
				map: null,
				userPoint: {
					"lat": "",
					"lng": "",
				},
				isNavigating: false,
				isPositionReady: false,
				geolocation: null,
				drivingRoute: null
			}
		},
		created() {
			this.merchantName = this.$route.params.busname
			const lat = this.$route.params.lat
			const lng = this.$route.params.lng
			this.merchantLat = lat
			this.merchantLng = lng
		},
		computed: {
			merchantPoint() {
				return {
					lat: parseFloat(this.merchantLat),
					lng: parseFloat(this.merchantLng)
				}
			},
			formattedMerchantPoint() {
				return `${this.merchantPoint.lat.toFixed(6)}, ${this.merchantPoint.lng.toFixed(6)}`
			},
			formattedUserPoint() {
				if (!this.userPoint) return '定位中...'
				return `${this.userPoint.lat.toFixed(6)}, ${this.userPoint.lng.toFixed(6)}`
			}
		},
		mounted() {
			this.initMap()
			this.getCurrentPosition()
		},
		beforeDestroy() {
			// 清理资源
			if (this.map && this.map.destroy) {
				this.map.destroy()
			}
		},
		methods: {
			openBaiduNav() {
				const encodedName = encodeURIComponent(this.merchantName);
				if (this.isMobile()) {
					let url =
						`https://map.baidu.com/mobile/webapp/place/detail?qt=ninf&wd=${encodedName}&lat=${this.merchantLat}&lng=${this.merchantLng}&mode=driving&da_src=myVueApp`;
					window.location.href = url
				} else {
					let url =
						`https://map.baidu.com/?navi_type=ROUTE&route_type=driving&lat=${this.merchantLat}&lng=${this.merchantLng}&name=${encodedName}&coord_type=wgs84`
					window.location.href = url
				}
			},
			toList() {
				this.$router.push('/businesslist')
			},
			initMap() {
				this.map = new BMap.Map(this.$refs.mapContainer)
				this.map.centerAndZoom(new BMap.Point(this.merchantPoint.lng, this.merchantPoint.lat), 15)
				this.map.enableScrollWheelZoom()
				this.map.addControl(new BMap.NavigationControl())
				this.map.addControl(new BMap.ScaleControl())

				// 添加商户标记
				const merchantMarker = new BMap.Marker(new BMap.Point(this.merchantPoint.lng, this.merchantPoint.lat))
				this.map.addOverlay(merchantMarker)

				// 添加商户信息窗口
				const merchantInfoWindow = new BMap.InfoWindow('目标商户位置')
				merchantMarker.addEventListener('click', () => {
					merchantMarker.openInfoWindow(merchantInfoWindow)
				})
			},
			isMobile() {
				return /Mobile|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i
					.test(navigator.userAgent);
			},
			fetchCurrentCoordinates() {
				let defaultatLng = {
					lat: 39.9075,
					lng: 116.3881
				}
				if (this.isMobile()) {
					return new Promise((resolve, reject) => {
						if (navigator.geolocation) {
							navigator.geolocation.getCurrentPosition(
								(position) => {
									resolve({
										lat: position.coords.latitude || defaultatLng.lat, // 默认值111
										lng: position.coords.longitude || defaultatLng.lng // 默认值222
									});
								},
								(error) => {
									Message.error('geolocation error')
									resolve(defaultatLng);
								}
							);
						} else {
							Message.error('不支持geolocation')
							resolve(defaultatLng);
						}
					});
				} else {
					return new Promise((resolve, reject) => {
						const geolocation = new BMap.Geolocation();
						if (geolocation) {
							geolocation.getCurrentPosition(
								r => {
									console.log(r)
									if (r) {
										resolve({
											lat: r.point.lat,
											lng: r.point.lng
										});
									} else {
										reject(new Error('定位失败: '));
									}
								}, {
									enableHighAccuracy: true
								}
							);
						} else {
							console.error('浏览器不支持 BMap.Geolocation');
							reject(new Error('浏览器不支持 BMap.Geolocation'));
						}
					});
				}
			},
			async getCurrentPosition() {
				this.isPositionReady = false
				let coords = await this.fetchCurrentCoordinates()
				if (coords) {
					this.userPoint.lat = coords.lat
					this.userPoint.lng = coords.lng
					this.isPositionReady = true

					// 添加用户位置标记
					const userMarker = new BMap.Marker(this.userPoint)
					this.map.addOverlay(userMarker)

					// 添加用户信息窗口
					const userInfoWindow = new BMap.InfoWindow('我的当前位置')
					userMarker.addEventListener('click', () => {
						userMarker.openInfoWindow(userInfoWindow)
					})
				}
			},

			startNavigation() {
				if (!this.isPositionReady) {
					this.$message.warning('请等待定位完成')
					return
				}

				this.isNavigating = true

				// 清除之前的路线
				if (this.drivingRoute) {
					this.map.clearOverlays()
					this.initMap() // 重新初始化地图标记
				}

				this.drivingRoute = new BMap.DrivingRoute(this.map, {
					renderOptions: {
						map: this.map,
						autoViewport: true,
						panel: null
					},
					onSearchComplete: results => {
						if (results && this.drivingRoute.getStatus() === BMAP_STATUS_SUCCESS) {
							const plan = results.getPlan(0);
							if (plan) {
								const distance = plan.getDistance ? (plan.getDistance() / 1000).toFixed(2) :
									'未知';
								const duration = plan.getDuration ? Math.ceil(plan.getDuration() / 60) : '未知';
								this.$message.success(`导航路线已规划，距离${distance}公里，预计${duration}分钟`);
							} else {
								this.$message.error('无法获取路线详情');
							}
						} else {
							this.$message.error('路线规划失败，请重试');
						}
						this.isNavigating = false;
					}
				})

				this.drivingRoute.search(
					new BMap.Point(this.userPoint.lng, this.userPoint.lat),
					new BMap.Point(this.merchantPoint.lng, this.merchantPoint.lat)
				)
			}
		}
	}
</script>

<style scoped>
	.map-container {
		width: 100%;
		height: 100%;
		display: flex;
		flex-direction: column;
	}

	#map {
		flex: 1;
		min-height: 400px;
		border-radius: 8px;
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
	}

	.controls {
		margin-top: 16px;
		display: flex;
		flex-direction: column;
		gap: 12px;
	}

	.nav-btn {
		padding: 10px 16px;
		background-color: #1890ff;
		color: white;
		border: none;
		border-radius: 4px;
		cursor: pointer;
		font-size: 16px;
		transition: background-color 0.3s;
	}

	.nav-btn:hover {
		background-color: #40a9ff;
	}

	.nav-btn:disabled {
		background-color: #d9d9d9;
		cursor: not-allowed;
	}

	.location-info {
		background-color: #f5f5f5;
		padding: 12px;
		border-radius: 4px;
	}

	.location-info p {
		margin: 4px 0;
		font-size: 14px;
	}

	.label {
		font-weight: bold;
		color: #333;
	}
</style>